import React, { useEffect, useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import MultiInputTag from "./MultiInputTag";

const defaultIcon = "facebook";
const NestedInput = ({ item, text }) => {
  const { label, name, type, multiple, multipleData, required } = item;

  const [indexState, setIndexState] = useState(multipleData?.length);
  const [elementCount, setElementCount] = useState(
    multipleData
      ? multipleData.map((item) => (
          <MultiInputTag
            key={item.label}
            label={item.label}
            name={item.name}
            type={type}
            required={required}
            defaultValue={item.defaultValue}
            icon={item.defaultValue?.name}
            handleRemoveElement={handleRemoveElement}
          />
        ))
      : [
          <MultiInputTag
            key={label}
            label={label}
            name={name}
            type={type}
            required={required}
            length={1}
            icon={defaultIcon}
            handleRemoveElement={handleRemoveElement}
          />,
        ]
  );

  // ADD
  function handleAddElement2() {
    setElementCount((current) => [
      ...current,
      <MultiInputTag
        key={`${label} ${indexState + 1}`} // ${label} ${indexState + 1}
        label={`${label} ${indexState + 1}`}
        name={name}
        type={type}
        required={required}
        icon={defaultIcon}
        handleRemoveElement={handleRemoveElement}
      />,
    ]);
    // setIndexState((old) => old + 1);
  }

  useEffect(() => {
    setIndexState(elementCount.length);
  }, [elementCount]);

  // DELETE
  function handleRemoveElement(label, index) {
    const reStoreValue = [...elementCount];
    const filteredvalue = reStoreValue.filter(
      (item) => !item.props.label.includes(label)
    );
    setElementCount(filteredvalue);
  }

  return (
    <div className="col-span-2 w-full flex flex-row gap-8 items-centers">
      <div className="col-span-2 w-full">
        {/* {quantityCount
          ? quantityCount.map((item, index) => (
              <div key={index}>{element(item, index)}</div>
            ))
          : elementNew()} */}
        {elementCount?.map((item) => item)}
      </div>

      {multiple && (
        <div className="flex justify-start w-full items-end">
          <button
            onClick={handleAddElement2}
            type="button"
            className="p-4 border rounded-full dark:border-gray-700 border-gray-400 border-dashed hover:border-darkPrimary transition duration-150"
          >
            <BsPlusLg />
          </button>
        </div>
      )}
    </div>
  );
};

export default NestedInput;

// const element = (item, index) => {
//   return text ? (
//     <MultiInputTagText
//       label={label}
//       length={index + 1}
//       name={name}
//       nameDefaultValue={item.defaultValue[0]}
//       defaultValue={item.defaultValue[1]}
//       type={type}
//       required={required}
//     />
//   ) : (
//     <MultiInputTag
//       label={label}
//       length={index + 1}
//       name={name}
//       icon={item.defaultValue.name}
//       defaultValue={item.defaultValue}
//       type={type}
//       required={required}
//     />
//   );
// };

// const elementNew = () => {
//   return text ? (
//     <MultiInputTagText
//       label={label}
//       name={name}
//       type={type}
//       required={required}
//     />
//   ) : (
//     <MultiInputTag
//       label={label}
//       name={name}
//       type={type}
//       required={required}
//     />
//   );
// };

// const handleAddElement = () => {
//   setCount((current) => [
//     ...current,
//     {
//       label: label,
//       type: "text",
//       name: "",
//       defaultValue: [],
//     },
//   ]);
// };

// const [quantityCount, setCount] = useState(
//   multipleData
//     ? multipleData
//     : [
//         {
//           label: label,
//           type: "text",
//           name: "",
//           defaultValue: [],
//         },
//       ]
// );
